import { QueryHookOptions, useQuery } from '@apollo/client';
import {
  GetOrderItem,
  GetOrderItemVariables,
} from '_graphql/queries/__generated__/GetOrderItem';
import { getOrders } from '_graphql/queries/orders';

export const useProductOrders = (
  options?: QueryHookOptions<GetOrderItem, GetOrderItemVariables>
) => {
  const { data, ...rest } = useQuery<GetOrderItem, GetOrderItemVariables>(
    getOrders,
    options
  );

  return {
    orders: data?.rows || [],
    count: data?.count || 0,
    ...rest,
  };
};
